import { CART_STATUS } from '../../constants';
import { shouldFinalizeSuccessForCart } from './resolveCartInstance';

const RETRYABLE_CHECKOUT_STATUSES = new Set([
  CART_STATUS.ACTIVE,
  CART_STATUS.PAYMENT_FAILED,
  CART_STATUS.PAYMENT_CANCELLED_BY_USER,
]);

/**
 * True when a cart still in a retryable checkout state has a previous WiPay order id
 * and checkout should replace it (failed/cancelled attempt or user retry). `isProcessing`
 * on the page prevents double-submit from the same session.
 */
export function shouldReplacePendingOrderId({
  existingOrderId,
  currentStatus,
  wipayOrderId,
}) {
  return Boolean(
    existingOrderId &&
    RETRYABLE_CHECKOUT_STATUSES.has(currentStatus) &&
    existingOrderId !== wipayOrderId
  );
}

/**
 * After checkout retry replaces cart.orderid, a WiPay callback may arrive for the
 * superseded order_id. Honor that payment only while the cart instance is still
 * unfulfilled; once awaiting_packing or beyond, skip fulfillment side effects to
 * avoid duplicate transactions and inventory decrements.
 */
export function shouldFulfillSupersededOrderPayment(cartInstance, orderId) {
  if (!cartInstance || !orderId) {
    return true;
  }

  const currentOrderId = cartInstance.orderid;
  if (!currentOrderId || currentOrderId === orderId) {
    return true;
  }

  // Align with shouldFinalizeSuccessForCart so we do not persist Transactions /
  // show Payment Successful when cart and inventory guards would skip fulfillment
  // (e.g. stale order_id after checkout retry without pendingCheckoutSnapshots).
  return shouldFinalizeSuccessForCart(cartInstance, orderId);
}
